import { render } from "./CreateRequest4.vue?vue&type=template&id=65e33ba1"
import script from "./CreateRequest4.vue?vue&type=script&lang=js"
export * from "./CreateRequest4.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__